import { createAsyncThunk } from '@reduxjs/toolkit';
import GeofenceService, {
  GeofenceLightDTO,
} from '../../services/geofence.service';
import { TableFilterDTO } from '../../global';

type GetSharedGeofencesPayload = {
  filters?: TableFilterDTO;
  onSuccess?: (response: GeofenceLightDTO[]) => void;
};

export const getSharedGeofences = createAsyncThunk(
  'shared/geofences',
  async (
    { filters, onSuccess }: GetSharedGeofencesPayload,
    { rejectWithValue },
  ) => {
    const { ok, data, error } = await GeofenceService.getGeofences(filters);

    if (ok) {
      onSuccess?.(data.items);
      return data;
    }
    return rejectWithValue(error);
  },
);
